export var CoverageArea;
(function (CoverageArea) {
    CoverageArea["BOTTOM"] = "BOTTOM";
    CoverageArea["TOP"] = "TOP";
})(CoverageArea || (CoverageArea = {}));
export var CoverageColor;
(function (CoverageColor) {
    CoverageColor["BLACK"] = "BLACK";
    CoverageColor["GRAY"] = "GRAY";
    CoverageColor["WHITE"] = "WHITE";
})(CoverageColor || (CoverageColor = {}));
export var CoverageLevel;
(function (CoverageLevel) {
    CoverageLevel["MAXIMUM"] = "MAXIMUM";
    CoverageLevel["MINIMAL"] = "MINIMAL";
    CoverageLevel["MODERATE"] = "MODERATE";
})(CoverageLevel || (CoverageLevel = {}));
export var SkinTone;
(function (SkinTone) {
    SkinTone["BROWN_0"] = "BROWN_0";
    SkinTone["BROWN_1"] = "BROWN_1";
    SkinTone["BROWN_2"] = "BROWN_2";
    SkinTone["BROWN_3"] = "BROWN_3";
    SkinTone["BROWN_4"] = "BROWN_4";
    SkinTone["BROWN_5"] = "BROWN_5";
    SkinTone["BROWN_6"] = "BROWN_6";
    SkinTone["BROWN_7"] = "BROWN_7";
    SkinTone["BROWN_8"] = "BROWN_8";
    SkinTone["BROWN_9"] = "BROWN_9";
    SkinTone["BLACK"] = "BLACK";
    SkinTone["GRAY"] = "GRAY";
    SkinTone["WHITE"] = "WHITE";
})(SkinTone || (SkinTone = {}));
